import apiRequest from '@lib/api-fetch';

export async function validateLoginBuyer(
    cart_id: string,
    email: string,
    phone: string,
    currentAmountOfCard: number,
    currentDollarValue: number
): Promise<any> {
    try {
        const response = await apiRequest(
            'POST',
            `/limit/validate-add-to-cart/${cart_id}`,
            {
                body: {
                    email,
                    phone,
                    currentAmountOfCard,
                    currentDollarValue,
                },
            }
        );
        return response.body;
    } catch (error) {
        console.error('Error validating login buyer:', error);
        throw error;
    }
}

export async function passwordLessSend(param: any): Promise<any> {
    return await apiRequest('POST', `/password-less/send`, {
        body: param,
    });
}

export async function passwordLessValidate(token: string): Promise<any> {
    return await apiRequest('GET', `/password-less/validate?token=${token}`);
}
